import React from 'react';

interface StalenessPromptProps {
  ageDays: number;
  onRunFresh: () => void;
  onUseOld: () => void;
}

// Shown when an 'auto' Keeper assessment finds an Oracle analysis older than the
// staleness threshold. No Gemini Keeper call has been made yet — the user picks
// between a fresh Oracle run and reusing the old analysis. Shared by the desktop
// row and the mobile card so both surfaces prompt identically.
export function StalenessPrompt({ ageDays, onRunFresh, onUseOld }: StalenessPromptProps) {
  return (
    <div className="bg-warning-50 border border-warning-100 rounded-md p-3">
      <p className="text-xs text-warning-700 font-medium mb-2">
        ⚠ Analysis is {ageDays} days old
      </p>
      <div className="flex gap-2">
        <button
          onClick={onRunFresh}
          className="flex-1 text-xs font-medium py-1.5 rounded-md bg-oxblood text-paper hover:bg-oxblood-800 transition-colors"
        >
          Run Fresh
        </button>
        <button
          onClick={onUseOld}
          className="flex-1 text-xs font-medium py-1.5 rounded-md bg-warning-50 text-warning-700 border border-warning-100 hover:bg-warning-100 transition-colors"
        >
          Use Old ({ageDays}d)
        </button>
      </div>
    </div>
  );
}
